<div class="modal-header">
    <h4 class="modal-title">Bardro {{data.row ? 'Güncelle' : 'Ekle'}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="payrollForm">
        <div class="row">
            <div class="col-6">
                <label for="grossSalary">Brüt</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="name" formControlName="grossSalary" />
                    </div>
                </div>
            </div>

            <div class="col-6">
                <label for="interruption">Kestinti</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="name" formControlName="interruption" />
                    </div>
                </div>
            </div>

            <div class="col-6">
                <label for="netSalary">Net</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="name" formControlName="netSalary" />
                    </div>
                </div>
            </div>

            <div class="col-6">
                <label for="supplementaryPayment">Ek Ödeme</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="name" formControlName="supplementaryPayment" />
                    </div>
                </div>
            </div>

            <div class="col-6">
                <label for="totalPayment">Total Ödeme</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="name" formControlName="totalPayment" />
                    </div>
                </div>
            </div>

            <div class="col-6">
                <label for="startDate">Period Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" formControlName="periodDate"
                        [setDate]="date"></ng2-flatpickr>
                </div>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
    <button type="button" class="btn btn-success" [disabled]="!payrollForm.valid" (click)="onSumbit()">{{data.row ?
        'Güncelle' : 'Kaydet'}}</button>
</div>